import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchSettings() {
  const { data } = await axios.get(`${API}/settings`);
  return data;
}

export async function saveSettings(adminKey, payload) {
  const { data } = await axios.post(`${API}/settings`, payload, {
    headers: { "X-Admin-Key": adminKey },
  });
  return data;
}

export async function createOrder(payload) {
  const { data } = await axios.post(`${API}/orders`, payload);
  return data;
}

export async function createCheckout(orderNumber, promo = false) {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    order_number: orderNumber,
    origin_url: window.location.origin,
    promo,
  });
  return data;
}

export async function createLead(email) {
  const { data } = await axios.post(`${API}/leads`, { email });
  return data;
}

export async function fetchOrders(adminKey) {
  const { data } = await axios.get(`${API}/orders`, {
    headers: { "X-Admin-Key": adminKey },
  });
  return data;
}
